import Service, { service } from '@ember/service';
import { task, all } from 'ember-concurrency';
import { waitFor } from '@ember/test-waiters';
import { isTesting, macroCondition } from '@embroider/macros';

import { findAll } from '@ember-data/legacy-compat/builders';

export default class DataPreloader extends Service {
  @service currentUser;
  @service store;
  @service notifier;
  @service licensing;
  @service session;

  loadCurrentUserAndData = task(waitFor(async () => {
    if (!this.session.isAuthenticated) {
      return;
    }

    const spinner = this.#addBodySpinner();

    const store = this.store;
    try {
      await store.request(findAll('system-configuration'));
      await this.licensing.loadLicense.perform();

      await all([
        store.findAll('work-instruction-folder'),
        store.findAll('area'),
        store.findAll('kinetic-part'),
        store.findAll('user'),
        store.findAll('hardware'),
        store.findAll('hardware-io'),
        store.findAll('hosted-file'),
        store.findAll('kinetic-shift'),
      ]);
      await all([
        store.findAll('model'),
        store.findAll('bom-source'),
        store.findAll('oee-button'),
        this.currentUser.setupUser.perform(),
      ]);

      if (!this.session.isOidc) {
        this.session.isActuallyAuthenticated = true;
      }
    } catch (error) {
      console.error(error);
      this.notifier.sendError('errorcomm');
      await this.session.invalidate();
    } finally {
      spinner?.remove();
    }
  }));

  #addBodySpinner() {
    if (macroCondition(isTesting())) {
      return;
    }

    const spinner = document.createElement('div');
    spinner.classList.add(
      'spinner-overlay', 'h2', 'vh-100', 'd-flex', 'flex-column', 'align-items-center', 'justify-content-center',
    );

    spinner.innerHTML = `
      <div class="spinner spinner-border text-secondary" role="status"></div>
    `;

    document.body.prepend(spinner);
    return spinner;
  }
}
